import $ from 'jquery';
import { Accordion } from 'foundation-sites';

window.addEventListener('load', function() {

  // Foundation Accordion
  const accordion = $('.js-accordion');
  if (accordion.length) {
    const accordionEl = new Accordion(accordion);
  }

});
